<template>
  <i v-if="!confirm" :class="icon || 'bxr bx-trash'" @click="waitForConfirm" />
  <i v-else-if="!loading" :class="confirmIcon || 'bxr bx-trash-x red'" @click="confirmed" />
  <i class="bxr bx-loader-dots loading" v-else></i>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

const confirm = ref(false)
const loading = ref(false)

defineProps<{
  icon?: string
  confirmIcon?: string
}>()

const emit = defineEmits<{
  (e: 'yes'): void
  (e: 'no'): void
}>()

function waitForConfirm() {
  confirm.value = true
  setTimeout(() => {
    if (!loading.value) {
      confirm.value = false
      emit('no')
    }
  }, 3000)
}

function confirmed() {
  emit('yes')
  loading.value = true
}
</script>
